export default {"src":"/_next/static/media/loanhand.72581a0a.svg","height":276,"width":370,"blurWidth":0,"blurHeight":0};